import { datadogLogs } from '@datadog/browser-logs';
const moment = require('moment');

export const saveToken = (token, setTokenLoading) => {
    setTokenLoading(true);
    localStorage.setItem('token', token);
    setDatadogUserID(token);
    setTokenLoading(false);
}

export const setDatadogUserID = (token) => {
    if (!token) return false;

    const payload = parseJWT(token);
    if (!payload || !payload.mId) return false;

    const userId = payload.mId;
    datadogLogs.setUser({ id: userId });
    return true;
};

const parseJWT = (token) => {
    try {
        const payloadBase64 = token.split('.')[1];
        const decoded = atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'));
        return JSON.parse(decoded);
    } catch (e) {
        console.error('Invalid JWT', e);
        return null;
    }
}

export const getDateTime = (timestamp, mode) => {
    let localTime = moment.unix(timestamp)
    if (mode === "unix") {
        localTime = moment.utc(timestamp).local();
    }
    const dateString = localTime.format('DD MMM YYYY');
    const timeString = localTime.format('hh:mm a');
    return dateString + " • " + timeString;
}

export const showButtonByTime = (timestamp, chatTime) => {
    const time = moment.unix(timestamp);
    const hourDiff = moment().diff(time, "hours")
    if (hourDiff < chatTime) return true;
    return false;
}

export const getTripPrice = (price) => {
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
     });
    return !isNaN(price) ? formatter.format(price) :  "...";
}

export const getFirstLetterCapital = (issue) => {
    return issue[0].toUpperCase() + issue.slice(1)
}

export const getCharacterCount = (field, fields) => {
    const f = fields.filter(f => f.name === field.label)[0];
    return f ? f.value.length : 0;
}

export const normalizeServiceType = (serviceType) => {
    return serviceType?.replace(/\s+/g, '').toLowerCase();
}

export const showArticleformByStatusAndServiceType = (articleLabels, tripStatus, serviceType) => {

    if (!articleLabels || articleLabels?.length === 0) {
        return false
    }

    let count = 0
    for (const label of articleLabels) {
        if (label.toLowerCase() === normalizeServiceType(serviceType) || label.toLowerCase() === `${tripStatus.toLowerCase()}_trip`) {
            count++
            if (count === 2) {
                return true
            }
        }
    }
    return false
}
